import {Button} from '@mantine/core';
import React from 'react';

import {useThrowValidationExceptionMutation} from 'src/redux/queries/admin';
import {useAlert} from 'src/shared/hooks/useAlert';
import {parseErrorMessage} from 'src/shared/utils/parseErrorMessage';

export const ThrowValidationExceptionButton: React.FC = () => {
  const [throwValidationException, {isLoading}] =
    useThrowValidationExceptionMutation();
  const {setAlert} = useAlert();

  const handleClick = async () => {
    try {
      await throwValidationException().unwrap();
    } catch (error) {
      setAlert(parseErrorMessage(error), 'error');
    }
  };

  return (
    <Button size="sm" onClick={handleClick} loading={isLoading}>
      Throw Validation Exception
    </Button>
  );
};
